module.exports = __webpack_public_path__ + "img/Desk Stationary A33.fa7c10a1.jpg";